(() => {
  if (window.donglinMetricaInstalled || window.Shopify?.designMode) return;
  window.donglinMetricaInstalled = true;

  const counterId = 113351154;
  const scriptUrl = 'https://mc.yandex.ru/metrika/tag.js?id=' + counterId;
  const goals = ['request_quote_click', 'quote_form_submit_success'];
  let active = false;
  let waiting = [];

  const permission = () => {
    const privacy = window.Shopify?.customerPrivacy;
    if (typeof privacy?.analyticsProcessingAllowed !== 'function') return null;
    return privacy.analyticsProcessingAllowed() === true;
  };

  const parameters = (detail = {}) => {
    const result = { storefront_locale: document.documentElement.lang };
    if (typeof detail.product_handle === 'string' && /^[a-z0-9-]{1,250}$/.test(detail.product_handle)) {
      result.product_handle = detail.product_handle;
    }
    if (typeof detail.enquiry_source === 'string') {
      try {
        const source = new URL(detail.enquiry_source, location.origin);
        if (source.origin === location.origin) result.enquiry_source = source.origin + source.pathname;
      } catch {}
    }
    return result;
  };

  const start = () => {
    if (active || permission() !== true) return;
    window.ym = window.ym || function () {
      (window.ym.a = window.ym.a || []).push(arguments);
    };
    window.ym.l = window.ym.l || Date.now();
    active = true;
    window.ym(counterId, 'init', {
      ssr: true,
      clickmap: true,
      ecommerce: 'dataLayer',
      referrer: document.referrer,
      url: location.href,
      accurateTrackBounce: true,
      trackLinks: true,
      webvisor: false
    });
    if (!Array.from(document.scripts).some(script => script.src === scriptUrl)) {
      const script = document.createElement('script');
      script.async = true;
      script.src = scriptUrl;
      document.head.appendChild(script);
    }
  };

  const sync = () => {
    const allowed = permission();
    if (allowed === null) return;
    if (!allowed) {
      waiting = [];
      if (active && typeof window.ym === 'function') {
        if (Array.isArray(window.ym.a)) {
          window.ym.a = window.ym.a.filter(call => call[0] !== counterId);
        }
        window.ym(counterId, 'destruct');
      }
      active = false;
      return;
    }
    start();
    const pending = waiting;
    waiting = [];
    pending.forEach(item => window.ym(counterId, 'reachGoal', item.name, item.params));
  };

  goals.forEach(name => {
    window.addEventListener('donglin:' + name, event => {
      const allowed = permission();
      if (allowed === false) return;
      const item = { name, params: parameters(event.detail) };
      if (allowed === null) {
        if (waiting.length < 10) waiting.push(item);
        return;
      }
      sync();
      window.ym(counterId, 'reachGoal', name, item.params);
    });
  });

  document.addEventListener('visitorConsentCollected', sync);
  let attempts = 0;
  const ready = () => {
    if (permission() !== null) {
      sync();
    } else if (typeof window.Shopify?.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
        if (!error) sync();
      });
    } else if (attempts++ < 20) {
      setTimeout(ready, 250);
    }
  };
  ready();
})();
